import React, { useEffect } from "react";
import { FeedLikeType, UserFeedsType } from "../../types";
import { AiOutlineClose } from "react-icons/ai";
import {
  UserFeedMenu,
  UserFeedModalContent,
  UserActivity,
  UserFeedCommentPost,
  UserCommentList,
  UserModalActivityReader,
  CommunityFooter,
  UserCommentModal,
  UserFeedImages,
  UserFeedImageVideo,
  UserFeedVideo,
} from "..";
import { useSelector } from "react-redux";
import { CREATE_FEED_COMMENT } from "../../apollo/operations";
import { useMutation } from "@apollo/client";
import { showToast } from "../../utils/showToast";

type UserFeedModalProps = {
  openModal: boolean;
  onClose: () => void;
  textArea: React.RefObject<HTMLTextAreaElement | null>;
  refetch: () => void;
  userFeed: UserFeedsType | undefined;
  feedLikes: FeedLikeType | undefined;
  refetchLikes: () => void;
  loadingLikes: boolean;
  inputArea: React.RefObject<HTMLInputElement | null>;
  feedImages: string[] | undefined;
  feedVideo?: string[];
  index: number;
  isLoading: boolean;
  isLocked?: boolean | (() => void);
  loadings: boolean;
  setLoadings: React.Dispatch<React.SetStateAction<boolean>>;
  setModalRemove: (value: React.SetStateAction<boolean>) => void;
  modalRemove: boolean;
};
const UserFeedModal: React.FC<UserFeedModalProps> = ({
  openModal,
  onClose,
  textArea,
  userFeed,
  refetch,
  refetchLikes,
  loadingLikes,
  inputArea,
  feedLikes,
  feedImages,
  feedVideo,
  index,
  isLoading,
  isLocked,
  setLoadings,
  loadings,
  setModalRemove,
  modalRemove,
}) => {
  // const textareaRef = React.useRef<HTMLTextAreaElement | null>(null);
  const [onChange, setOnChange] = React.useState(false);
  const [showAllImages, setShowAllImages] = React.useState<number | null>(null);
  const [editContent] = React.useState(false);

  const user = useSelector((state: any) => state.user.userDetails);
  const [userComment, setUserComment] = React.useState("");

  const [createComment, { loading }] = useMutation(CREATE_FEED_COMMENT, {
    onCompleted(data) {
      console.log(data);

      if (refetch) {
        refetch();
      }
      setUserComment("");
    },
    onError: (err) => {
      console.log(err);
      const errorMessage = err.graphQLErrors[0]?.extensions?.originalError;
      console.log(errorMessage);
    },
  });

  const handleSubmit = (e: any) => {
    e.preventDefault();
    if (userFeed?.id && user?.id) {
      createComment({
        variables: {
          data: {
            comments: userComment,
            userFeed: {
              id: userFeed?.id,
            },
            creator: {
              id: user?.id,
            },
          },
        },
      }).then(() => {
        console.log("submitted");
        setOnChange(false);
      });
    } else {
      showToast("You need to log in", "warn");
      // navigate("/auth");
    }
  };

  useEffect(() => {
    if (!loadingLikes) {
      setLoadings(false);
      setModalRemove(false);
    }
  }, [loadingLikes, setLoadings, setModalRemove]);

  if (showAllImages !== null) {
    document.body.classList.add("picModal");
    console.log("its hidden");
  } else {
    document.body.classList.remove("picModal");
  }

  return (
    <div
      className={`fixed inset-0 z-30 flex lg:justify-center lg:py-10 pb-[100px] lg:pb-[80px]
      transition-colors overflow-y-hidden ${
        openModal && isLocked
          ? "visible backdrop-filter backdrop-blur-[6px] bg-[#FFFFFFB8]"
          : "invisible"
      }`}
      onClick={onClose}
    >
      <div
        className={`bg-white rounded-md shadow-md  
       transition-all lg:w-[45%] w-full  ${
         openModal && isLocked ? "scale-100 opacity-100" : "scale-110 opacity-0"
       }`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="sticky z-20 shadow w-[100%] flex justify-between items-center p-2">
          <div className="flex flex-1 justify-center text-[#323232] items-center font-Poppins font-medium text-lg">
            {`${userFeed?.creator.firstName} ${userFeed?.creator.lastName}`}'s
            post
          </div>
          <button
            className="py-2 px-2
            rounded-full text-transBlack
            bg-comPagBg active:bg-bgGrey
            hover:text-gray-600"
            onClick={onClose}
          >
            {""}
            <AiOutlineClose size={20} />
          </button>
        </div>
        <div
          className="flex flex-col w-full bg-comPagBg lg:h-full pb-10 lg:pb-0 h-[90%] lg:overflow-hidden overflow-y-auto"
          key={index + 3}
        >
          <div className="w-full flex flex-col px-2 lg:px-0 shadow lg:shadow-none h-fit mb-2 py-4 bg-white lg:h-[98%] lg:overflow-y-auto">
            <div className="w-full mx-auto justify-between h-10 px-3 lg:px-5 flex">
              <UserFeedMenu userFeed={userFeed} />
              {/* <UserFeedOption
                userFeed={userFeed}
                setEditContent={setEditContent}
                refetch={refetch}
              /> */}
            </div>
            <UserFeedModalContent
              content={userFeed?.content}
              userFeed={userFeed}
              feedImages={feedImages}
              feedVideo={feedVideo}
            />
            {feedImages &&
            feedVideo &&
            feedImages.length > 0 &&
            feedVideo.length > 0 ? (
              <UserFeedImageVideo
                selectedVideos={feedVideo}
                imageUpload={feedImages}
                setShowAllImages={setShowAllImages}
                showAllImages={showAllImages}
              />
            ) : feedImages && feedImages.length > 0 ? (
              <UserFeedImages
                editCotent={editContent}
                key={index + 1}
                setShowAllImages={setShowAllImages}
                showAllImages={showAllImages}
                feedImages={feedImages}
              />
            ) : (
              feedVideo &&
              feedVideo.length > 0 && (
                <UserFeedVideo
                  videos={feedVideo}
                  key={index + 47}
                  setShowAllVideos={setShowAllImages}
                  showAllVideos={showAllImages}
                />
              )
            )}
            <div className="px-[15px] lg:mt-[-20px]">
              <UserModalActivityReader
                // feedLikes={feedLikes}
                userFeed={userFeed}
                loadings={loadings}
                modalRemove={modalRemove}
              />
              <UserActivity
                textArea={textArea}
                refetch={refetchLikes}
                user={user}
                inputArea={inputArea}
                userFeed={userFeed}
                feedLikes={feedLikes}
                refetchAllUserFeeds={refetch}
                setLoadings={setLoadings}
                setModalRemove={setModalRemove}
              />
            </div>

            <div className="hidden lg:flex lg:flex-col">
              {userFeed?.comments.map((userFeedComment) => (
                <UserCommentList
                  refetch={refetch}
                  userComments={userFeedComment}
                  userFeed={userFeed}
                  key={userFeedComment.id}
                  isLoading={isLoading}
                />
              ))}
            </div>
            <div className="flex flex-col lg:hidden w-full mt-2 gap-1 pb-3 overflow-y-auto px-2 h-full">
              {userFeed?.comments.map((userFeedComment) => (
                <UserCommentList
                  refetch={refetch}
                  userComments={userFeedComment}
                  userFeed={userFeed}
                  key={userFeedComment.id}
                  isLoading={isLoading}
                />
              ))}
            </div>
          </div>
          <div className="hidden lg:flex">
            <UserFeedCommentPost
              setUserComment={setUserComment}
              userComment={userComment}
              handleSubmit={handleSubmit}
              textArea={textArea}
              loading={loading}
            />
          </div>
        </div>
      </div>
      <div className="w-full fixed bottom-[69px]">
        <UserCommentModal
          setUserComment={setUserComment}
          userComment={userComment}
          handleSubmit={handleSubmit}
          textArea={textArea}
          loading={loading}
          onChange={onChange}
          setOnChange={setOnChange}
        />
      </div>
      <CommunityFooter />
    </div>
  );
};

export default UserFeedModal;
